/**
 * Плагин: по событию графа connection:label:updated шлёт patch updateConnectionLabel.
 */
export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const onLabelUpdated = ({connectionViewId, label} = {}) => {
			if (connectionViewId == null) return;
			onPatch({
				patches: [
					{
						op: 'updateConnectionLabel',
						viewIndex: VIEW_INDEX,
						identifier: connectionViewId,
						label: label ?? '',
					},
				],
			});
		};

		graph.on('connection:label:updated', onLabelUpdated);

		return () => graph.off('connection:label:updated', onLabelUpdated);
	},
};
